// constants
import { CurrencyActionTypes } from "./constants";

export interface CurrencyActionType {
  type:
    | CurrencyActionTypes.API_RESPONSE_SUCCESS
    | CurrencyActionTypes.API_RESPONSE_ERROR
    | CurrencyActionTypes.UPDATE_CURRENCY
    | CurrencyActionTypes.CREATE_CURRENCY
    | CurrencyActionTypes.GET_CURRENCY
    | CurrencyActionTypes.DELETE_CURRENCY;
  payload: {} | string;
}

interface categoryDetails {
  id: string;
  currency_name: string;
  currency_flag: string;
  currency_code: string;
  currency_rate: string;
}

// common success
export const currencyApiResponseSuccess = (
  actionType: string,
  data: categoryDetails | {}
): CurrencyActionType => ({
  type: CurrencyActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const currencyApiResponseError = (
  actionType: string,
  error: string
): CurrencyActionType => ({
  type: CurrencyActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createCurrency = (
  currency_name: string,
  currency_flag: string,
  currency_code: string,
  currency_rate: string
): CurrencyActionType => ({
  type: CurrencyActionTypes.CREATE_CURRENCY,
  payload: {
    currency_name,
    currency_flag,
    currency_code,
    currency_rate,
  },
});

export const getCurrency = (): CurrencyActionType => ({
  type: CurrencyActionTypes.GET_CURRENCY,
  payload: {},
});

export const deleteCurrency = (id: string): CurrencyActionType => ({
  type: CurrencyActionTypes.DELETE_CURRENCY,
  payload: { id },
});
export const updateCurrency = (
  id: string,
  currency_name: string | null = null,
  currency_flag: string | null = null,
  currency_code: string | null = null,
  currency_rate: string | null = null,
  isActive: any | null = null
): CurrencyActionType => ({
  type: CurrencyActionTypes.UPDATE_CURRENCY,
  payload: {
    id,
    currency_name,
    currency_flag,
    currency_code,
    currency_rate,
    isActive,
  },
});
